import { Select, SelectProps } from 'antd';
import { useRef } from 'react';

function TagSelect<ValueType = any>(props: SelectProps<ValueType>) {
  const ref = useRef<any>(null);

  return (
    <div onClickCapture={() => ref.current.focus()}>
      <Select ref={ref} {...props} />
    </div>
  );
}

export default TagSelect;
